var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "site-header",
      class: [{ open: _vm.isOpen }, { "open-mega": _vm.isMegaOpen }],
      attrs: { id: "site-header" }
    },
    [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "content-max-width flex" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "right-links" }, [
            _c(
              "ul",
              _vm._l(_vm.top_links, function(item, index) {
                return _c("li", { key: index }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: item.url,
                        target: item.is_external ? "_blank" : "_self"
                      }
                    },
                    [
                      _vm._v(_vm._s(item.title)),
                      item.children.length
                        ? _c("img", {
                            attrs: { src: "/images/top-dropdown.svg", alt: "" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  item.children.length
                    ? _c(
                        "div",
                        { staticClass: "dropdown" },
                        _vm._l(item.children, function(child, i) {
                          return _c(
                            "a",
                            {
                              key: i,
                              attrs: {
                                href: child.url,
                                target: child.is_external ? "_blank" : "_self"
                              }
                            },
                            [_vm._v(_vm._s(child.title))]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-search" }, [
            _c("img", {
              attrs: { src: "/images/search-dark.svg", alt: "Search" },
              on: { click: _vm.toggleDesktopSearch }
            }),
            _vm._v(" "),
            _vm.isDesktopSearchOpen
              ? _c("div", { staticClass: "search-open" }, [
                  _c("img", {
                    staticClass: "search",
                    attrs: { src: "/images/search-dark.svg", alt: "Search" }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.search },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.enterSearch.apply(null, arguments)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { on: { click: _vm.toggleDesktopSearch } }, [
                    _c(
                      "svg",
                      {
                        staticClass: "close",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "23",
                          height: "23",
                          fill: "#FFFFFF",
                          viewBox: "0 0 16 16"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                          }
                        })
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "hamburger mobile", on: { click: _vm.toggleMenu } },
        [_c("span"), _c("span"), _c("span")]
      ),
      _vm._v(" "),
      _vm.isSearchOpen
        ? _c("HeaderSearch", {
            attrs: {
              groups: _vm.groups,
              module_type: _vm.module_type,
              search_url: _vm.search_url,
              popular_searches: _vm.popular_searches,
              all_services: _vm.all_services
            },
            on: { close: _vm.closeSearch }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "mobile-menu" }, [
        _c("div", { staticClass: "header" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "close", on: { click: _vm.toggleMenu } }, [
            _c(
              "svg",
              {
                staticClass: "bi bi-x-lg",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "#313232",
                  viewBox: "0 0 16 16"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                  }
                })
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [
          _c(
            "div",
            { staticClass: "links" },
            [
              _vm._l(_vm.links, function(link) {
                return _c("Collapsible", {
                  key: link.id,
                  staticClass: "link",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "trigger",
                        fn: function(ref) {
                          var isOpen = ref.isOpen
                          var toggle = ref.toggle
                          return [
                            _c("h4", { on: { click: toggle } }, [
                              _vm._v(_vm._s(link.title))
                            ]),
                            _vm._v(" "),
                            _c("p", { on: { click: toggle } }, [
                              _vm._v(_vm._s(link.alt_text))
                            ])
                          ]
                        }
                      },
                      {
                        key: "collapsible",
                        fn: function(ref) {
                          var isOpen = ref.isOpen
                          var close = ref.close
                          return [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: isOpen,
                                    expression: "isOpen"
                                  }
                                ],
                                staticClass: "link-child"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "child-header flex flex-wrap"
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "/images/icons/return-to-top-dark.svg",
                                        alt: "Back"
                                      },
                                      on: { click: close }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "flex-1" }, [
                                      _c("h4", [_vm._v(_vm._s(link.title))]),
                                      _vm._v(" "),
                                      _c("p", [_vm._v(_vm._s(link.alt_text))])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(link.children, function(childLink) {
                                  return _c("Collapsible", {
                                    key: childLink.id,
                                    staticClass: "link-collapsible",
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "trigger",
                                          fn: function(ref) {
                                            var isOpen = ref.isOpen
                                            var toggle = ref.toggle
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "collapsible-header",
                                                  on: { click: toggle }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex-1" },
                                                    [
                                                      _c("h4", [
                                                        _vm._v(
                                                          _vm._s(
                                                            childLink.title
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            childLink.alt_text
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "svg",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: isOpen,
                                                          expression: "isOpen"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "bi bi-dash-lg",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "24",
                                                        height: "24",
                                                        fill: "#657781",
                                                        viewBox: "0 0 16 16"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          "fill-rule":
                                                            "evenodd",
                                                          d:
                                                            "M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "svg",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: !isOpen,
                                                          expression: "! isOpen"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "bi bi-plus-lg",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "24",
                                                        height: "24",
                                                        fill: "#657781",
                                                        viewBox: "0 0 16 16"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          "fill-rule":
                                                            "evenodd",
                                                          d:
                                                            "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "collapsible",
                                          fn: function(ref) {
                                            var isOpen = ref.isOpen
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: isOpen,
                                                      expression: "isOpen"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "collapsible-body"
                                                },
                                                _vm._l(
                                                  childLink.children,
                                                  function(grandChildLink) {
                                                    return _c(
                                                      "a",
                                                      {
                                                        key: grandChildLink.id,
                                                        attrs: {
                                                          href:
                                                            grandChildLink.url
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            grandChildLink.title
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                })
                              ],
                              2
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              _vm._v(" "),
              _vm._l(_vm.top_links, function(item, index) {
                return _c(
                  "a",
                  {
                    key: index,
                    staticClass: "link",
                    attrs: { href: item.url }
                  },
                  [_c("h4", [_vm._v(_vm._s(item.title))])]
                )
              })
            ],
            2
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo", attrs: { href: "/home" } }, [
      _c("img", {
        attrs: { src: "/images/logo-dark.svg", alt: "Habit Health logo" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "buttons" }, [
      _c("a", { staticClass: "button-login", attrs: { href: "/log-in" } }, [
        _vm._v("Log in")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "button-book", attrs: { href: "/book-now" } }, [
        _vm._v("Book Now")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo", attrs: { href: "" } }, [
      _c("img", { attrs: { src: "/images/logo.png", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "menu-buttons" }, [
      _c("a", { staticClass: "button-login", attrs: { href: "/log-in" } }, [
        _vm._v("Log in")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "button-book", attrs: { href: "/book-now" } }, [
        _vm._v("Book Now")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72144409", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72144409","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Header.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-72144409","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Header.vue
// module chunks = 0